import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'top-invoice-knock-off-selection',
  templateUrl: './top-invoice-knock-off-selection.component.html',
  styleUrls: ['./top-invoice-knock-off-selection.component.scss'],
})
export class TopInvoiceKnockOffSelectionComponent implements OnInit, OnChanges {

  isDropdownOpen: boolean = false;
  @Input() title: any;
  @Input() manualKnockOffData: any = {
    invoices: [],
    paymentDetails: {},
    payModel: {},
    invoiceData: {},
  };
  @Input() onListData: any = [];

  constructor() { }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
      // console.log("manualKnockOffData : ", changes.manualKnockOffData.currentValue);
      
  }

  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

}
